import React from 'react';

import { Text } from '../../../components';

const AddNewServiceTitle = () => (
  <Text text="Add service" size="l" />
)

export default AddNewServiceTitle
